import { useNavigate } from 'react-router-dom';
import { parsePhoneNumberFromString } from "libphonenumber-js";
import PhoneNumberField from '../../../common/PhoneNumberField';
import React, { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import { DialogContentText, IconButton, RadioGroup, FormControlLabel, Radio, InputLabel } from "@mui/material";
import { getCustomerDetailsByIdAction, updateCustomerDetailsAction } from "../../../redux/actions/customerDetailsAction";
import { getGeneralPartyInfoByIdDashboard, clearGpId, updateGeneralPartyInfo, getQuoteInfoByFields, getNewQuoteByGpid } from "../../../redux/actions/generalPartyInfoActions";
import Loader from "../../loader/loader";
import { driverLicenseState } from '../../../common/StaticFieldList';
import DatePickerField from '../../../common/DatePickerDashboard';
import DatePickerBot from "../../bot/DatePickerBot";
import dayjs from "dayjs";
import {
  Table,
  Box,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Typography,
  Button,
  Dialog,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  Backdrop,
  Select,
  FormControl,
  Pagination,
  MenuItem,
  useTheme,
  useMediaQuery,
   FormLabel,
} from "@mui/material";
import CustomerPolicyListing from "./CustomerPolicyListing";
import CommunicationTable from "../PolicyDetails/Communication";
import Attachments from "../../attachments/Attachments";
import { useSelector, useDispatch } from "react-redux";
import GlobalNotes from "./GlobalNotes";
import GlobalTask from "./GlobalTask";
import GlobalActivityLog from "./GlobalActivityLog";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import NoDataFound from '../../../common/NoDataFound';


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CustomerData = ({
  id,
  showPolicyDetails,
  clientCustomerId,
  selectedCustomerDetails,
  showCustomerData,
  selected_customer_list,
  get_selected_quote_data_pagination,
  customer_policy_pagination,
  get_selected_quote_data,
  customerRowsPerPage,
  customerPage,
  handleQuotePolicyChangePage,
  handleQuoteChangeRowsPerPage,
  handlePolicyRowClick,
  handlePolicyChangePage,
  handlePolicyChangeRowsPerPage,
  handleRowClickQuotes,
  policyPage,
  policyRowsPerPage,
  setSearchPerformed,
  tabValue,
  setTabValue,
  customerSelecteCustomer
}) => {
 const [displayData, setDisplayData] = useState({});

  const [accessDenied, setAccessDenied] = useState(false);


  const [openDialog, setOpenDialog] = useState(false);
  const [selectedOption, setSelectedOption] = useState("today");
  const [customDate, setCustomDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [selectedQuote, setSelectedQuote] = useState(null);
  const [generalData, setGeneralData] = useState(null);

  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const customerDetailsFromRedux = useSelector(state => state.customerDetails.selectedCustomerDetails);
  const updatedcustomerDetails = useSelector(state => state.customerDetails.selectedCustomer);
  const notesValue = useSelector((state) => state.note.allNote) || [];
  const notesTotalElement = notesValue.totalElements || 0;
  const taskData = useSelector((state) => state.task.allTask);
  const taskTotalElement = taskData.totalElements || 0;
  const isLoading = useSelector((state) => state.globalSearchReducer.loading);
  const [editOpen, setEditOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [fieldErrors, setFieldErrors] = useState({});
  const [touchedFields, setTouchedFields] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);
  const navigate = useNavigate();
 const [existingUsers, setExistingUsers] = useState([]);
   const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
 const [useGpId, setUseGpId] = useState(false);

  const parseQuoteDate = (dateString) => {
    if (!dateString) return null;

    let parsedDate;

    if (dateString.includes("-") && dateString.split("-").length === 3) {
      const parts = dateString.split("-");
      if (parts[0].length === 2) {
        parsedDate = dayjs(`${parts[2]}-${parts[0]}-${parts[1]}`);
      } else {
        parsedDate = dayjs(dateString);
      }
    } else {
      parsedDate = dayjs(dateString);
    }

    return parsedDate.isValid() ? parsedDate : null;
  };

  const handleCancelDialog = () => {
    setDialogOpen(false);
    // setHasCheckedExisting(false);
    setExistingUsers([]);
    setSelectedUser(null);
    setUseGpId(false);
     dispatch({ type: 'RESET_GLOBAL_SEARCH_LOADING' });
    //  setLoading(false);
  };
   const handleUserSelection = (user) => {
    setSelectedUser(user);
  };
   const handleGpIdChange = (event) => {
    setUseGpId(event.target.value === "yes");
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleProceedWithExistingDate = () => {
    setOpenDialog(false);
    proceedToNavigation(selectedQuote, generalData);
  };

  const handleSetEffectiveDate = () => {
    let newEffDate;
    if (selectedOption === "today") {
      newEffDate = dayjs().format("MM-DD-YYYY");
    } else if (selectedOption === "tomorrow") {
      newEffDate = dayjs().add(1, "day").format("MM-DD-YYYY");
    } else {
      newEffDate = dayjs(customDate).format("MM-DD-YYYY");
    }

    const updateFormData = {
      ...generalData,
      effectiveDate: newEffDate,
    };

    dispatch(
      updateGeneralPartyInfo(updateFormData, () => {
        const updatedGeneralData = { ...generalData, effectiveDate: newEffDate };
        const updatedQuote = { ...selectedQuote, effDate: newEffDate };
        setOpenDialog(false);
        proceedToNavigation(updatedQuote, updatedGeneralData);
      })
    );
  };


  const proceedToNavigation = (quote, generalData) => {
    if (!quote?.quoteNumber || !generalData) {
      console.error("quoteNumber or generalData is undefined or missing.");
      return;
    }

    navigate("/mainview", { state: { generalData, updatedQuote: quote } });
  };
  const proceedForExistingUser = (quote, generalData) => {
    if (!quote?.quoteId || !generalData) {
      console.error("quoteNumber or generalData is undefined or missing.");
      return;
    }

    navigate("/mainview", { state: { generalData, updatedQuote: quote } });
  };


  const handleRowClickQuotesWithDialog = async (quoteNumber) => {
    dispatch({ type: 'RESET_GLOBAL_SEARCH_LOADING' });
    if (!quoteNumber) return;

    dispatch(clearGpId());


    const selectedQuoteData = get_selected_quote_data.find(quote => quote.quoteNumber === quoteNumber);
    if (!selectedQuoteData) {
      console.error("Selected quote not found in quote data");
      return;
    }

    const today = dayjs().startOf("day");
    const effDate = parseQuoteDate(selectedQuoteData.effDate);

    const numericPart = quoteNumber.replace(/^Q0*/, "");

    try {
      const response = await dispatch(getGeneralPartyInfoByIdDashboard(numericPart));
      const fetchedGeneralData = response?.payload || response;

      if (fetchedGeneralData && Object.keys(fetchedGeneralData).length > 0) {
        setGeneralData(fetchedGeneralData);
        setSelectedQuote(selectedQuoteData);


        if (effDate && effDate.isValid() && effDate.isBefore(today)) {
          setOpenDialog(true);
        } else {

          proceedToNavigation(selectedQuoteData, fetchedGeneralData);
        }
      } else {
        console.error("No general data returned.");
      }
    } catch (error) {
      console.error("Error fetching general party info:", error);
    }
  };
 const handleConfirmDialog = async () => {
      dispatch({ type: 'RESET_GLOBAL_SEARCH_LOADING' });
      if (selectedUser) {
        try {
          if (useGpId) {
            const response = await dispatch(getNewQuoteByGpid(selectedUser.gpId));
            if (response) {
              const quoteId = response.quoteId;
              const gpid=response.gpId;

              const quoteData = await dispatch(getGeneralPartyInfoByIdDashboard(gpid));
              const fetchedGeneralData = quoteData?.payload || quoteData;
              if (!fetchedGeneralData || Object.keys(fetchedGeneralData).length === 0) {
                throw new Error("No general data returned");
              }proceedForExistingUser(response, fetchedGeneralData);
            }
          } else {
            // dispatch(clearGpId());
              dispatch({ type: "RESET_GENERALPARTYINFO" });
              dispatch({ type: "RESET_ALL_VEHICLE_INFO" });
              dispatch({ type: "RESET_ALL_DRIVER_INFO" });
              dispatch({ type: "RESET_ALL_RATES" });
             navigate("/", {
            state: {
              clientCustomerId: selectedUser.clientCustomerId, isNewQuote: true
            }
          });
          }
        } catch (error) {
          // handleSnackbarOpen("Error processing your request", "error");
        }
      }
      setDialogOpen(false);
    };
const handleDateChange = (fieldName, value) => {
  setFormData((prev) => ({ ...prev, [fieldName]: value }));
};

const handleBlur = (fieldName, errorMsg) => {
  setTouchedFields((prev) => ({ ...prev, [fieldName]: true }));
  setFieldErrors((prev) => ({ ...prev, [fieldName]: errorMsg }));
};

const digitsOnly = (v = "") => String(v).replace(/\D/g, "");
const toDisplayPhone = (val) => {
  const d = digitsOnly(val);
  const ten = d.length === 11 && d.startsWith("1") ? d.slice(1) : d.slice(0, 10);
  if (ten.length <= 3) return ten;
  if (ten.length <= 6) return `${ten.slice(0, 3)}-${ten.slice(3)}`;
  return `${ten.slice(0, 3)}-${ten.slice(3, 6)}-${ten.slice(6, 10)}`;
};
const toRaw10 = (val) => {
  const d = digitsOnly(val);
  if (d.length === 11 && d.startsWith("1")) return d.slice(1);
  if (d.length === 10) return d;
  return "";
};
const toE164FromRaw10 = (raw) => {
  if (!raw) return null;
  const digits = raw.replace(/\D/g, "");
  if (digits.length !== 10) return null;
  return `+1${digits}`;
};
const validateUSPhoneRaw10 = (raw) => {
  if (!raw) return "Phone number is required";
  if (raw.length !== 10) return "Phone number must be 10 digits";
  const parsed = parsePhoneNumberFromString(`+1${raw}`);
  if (!parsed || !parsed.isValid()) return "Invalid number";
  return "";
};

const formatPhoneNumberDisplay = (phoneNumber) => {
  if (!phoneNumber) return "";

  const cleaned = phoneNumber.startsWith('+1')
    ? phoneNumber.slice(2).replace(/\D/g, '')
    : phoneNumber.replace(/\D/g, '');

  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  return match ? `${match[1]}-${match[2]}-${match[3]}` : phoneNumber;
};

  const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return "";

  const cleaned = phoneNumber.startsWith('+1')
    ? phoneNumber.slice(2).replace(/\D/g, '')
    : phoneNumber.replace(/\D/g, '');

  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  return match ? `${match[1]}-${match[2]}-${match[3]}` : phoneNumber;
};

  const handleNameInput = (e) => {
    const { name, value } = e.target;
    const input = value.replace(/[^A-Za-z]/g, '');
    const limitedInput = input.slice(0, 30);
    setFormData(prev => ({
      ...prev,
      [name]: limitedInput
    }));

    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleZipCodeInput = (e) => {
    const { name, value } = e.target;
    const input = value.replace(/\D/g, '').slice(0, 5);

    setFormData(prev => ({
      ...prev,
      [name]: input
    }));

    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleAddressInput = (e) => {
    const { name, value } = e.target;
    const input = value.replace(/[^A-Za-z0-9\s]/g, '').slice(0, 75);

    setFormData(prev => ({
      ...prev,
      [name]: input
    }));

    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleCityStateInput = (e) => {
    const { name, value } = e.target;
    const input = value.replace(/[^A-Za-z\s]/g, '').slice(0, 30);

    setFormData(prev => ({
      ...prev,
      [name]: input
    }));

    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleEmailInput = (e) => {
    const { name, value } = e.target;
    const sanitizedInput = value.replace(/[^a-zA-Z0-9@.]/g, '');
    const atCount = (sanitizedInput.match(/@/g) || []).length;
    const dotCount = (sanitizedInput.match(/\./g) || []).length;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (atCount > 1 || dotCount > 1) {
      return;
    }

    const limitedInput = sanitizedInput.slice(0, 50);
    setFormData(prev => ({
      ...prev,
      [name]: limitedInput
    }));

    if (limitedInput && !emailRegex.test(limitedInput)) {
      setFormErrors(prev => ({
        ...prev,
        [name]: 'Invalid email format'
      }));
    } else {
      setFormErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };


const validateField = (name, value) => {
  switch (name) {
    case 'firstName':
    case 'lastName':
      if (!value || value.trim() === '') {
        return `${name === 'firstName' ? 'First' : 'Last'} name is required`;
      }
      if (value.length < 2) {
        return `${name === 'firstName' ? 'First' : 'Last'} name must be at least 2 characters`;
      }
      break;
    case 'email':
      if (!value || value.trim() === '') {
        return 'Email is required';
      }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(value)) {
        return 'Invalid email format. Use standard email format (e.g., user@example.com)';
      }
      break;
    case 'phoneNumber':
      if (!value || value.trim() === '') {
        return 'Phone number is required';
      }

      const digitsOnly = value.replace(/\D/g, '');

      if (digitsOnly.length !== 10) {
        return 'Phone number must be 10 digits';
      }


      const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
      if (!phoneRegex.test(value)) {
        return 'Phone number must be in xxx-xxx-xxxx format';
      }
      break;

    case 'dateOfBirth':
      if (!value || value.trim() === '') {
        return 'Date of Birth is required';
      }

      const birthDate = new Date(value);
      const today = new Date();

      today.setHours(0, 0, 0, 0);
      birthDate.setHours(0, 0, 0, 0);

      if (isNaN(birthDate.getTime())) {
        return 'Please enter a valid date';
      }

      if (birthDate > today) {
        return 'Date of Birth cannot be in the future';
      }

      const year = birthDate.getFullYear();
      const currentYear = today.getFullYear();

      if (year > currentYear) {
        return 'Birth year cannot be in the future';
      }

      const age = currentYear - year;
      const birthdayThisYear = new Date(currentYear, birthDate.getMonth(), birthDate.getDate());
      const actualAge = birthdayThisYear > today ? age - 1 : age;

      if (actualAge < 16) {
        return 'Person must be at least 16 years old';
      }
      if (actualAge > 120) {
        return 'Please enter a valid birth year (cannot be more than 120 years ago)';
      }
      if (year < 1900) {
        return 'Please enter a valid birth year (must be 1900 or later)';
      }
      break;
    case 'addressLine1':
      if (!value || value.trim() === '') {
        return 'Address is required';
      }
      break;
    case 'city':
      if (!value || value.trim() === '') {
        return 'City is required';
      }
      break;
    case 'state':
      if (!value || value.trim() === '') {
        return 'State is required';
      }
      break;
    case 'zipCode':
      if (!value || value.trim() === '') {
        return 'ZipCode is required';
      }
      if (value.length < 5 || value.length > 9) {
        return 'ZipCode must be 5-9 digits';
      }
      break;
    default:
      return '';
  }
  return '';
};

  const customerData = updatedcustomerDetails || customerDetailsFromRedux || selectedCustomerDetails;

  useEffect(() => {
    if (customerData) {

      const formattedCustomerData = {
        ...customerData,
        phoneNumber: toRaw10(customerData.phoneNumber),
      };
      setDisplayData(customerData);
      setFormData(formattedCustomerData);
    }
    if(showPolicyDetails){
      setTabValue(2);
    }
  }, [customerData, setTabValue]);


  const callbackfn = ({ success, status, errorMessage }) => {
    if (!success) {

      const isAccessDenied =
        errorMessage?.toLowerCase()?.includes("access denied");

      if (status === 403 || isAccessDenied) {
        setAccessDenied(true);
        setTabValue(0);
      }
    }
  };

  useEffect(() => {
    const customerId = selectedCustomerDetails?.id;

    if (customerId && showCustomerData && !customerDetailsFromRedux) {
      dispatch(getCustomerDetailsByIdAction(customerId, callbackfn));
    }
  }, [selectedCustomerDetails, showCustomerData, dispatch, customerDetailsFromRedux]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
  if (dialogOpen && existingUsers.length > 0 && !selectedUser) {
    setSelectedUser(existingUsers[existingUsers.length - 1]);
  }
}, [dialogOpen, existingUsers]);
const handleEditClick = () => {
  const formattedDisplayData = {
    ...displayData,
    phoneNumber: formatPhoneNumberDisplay(displayData.phoneNumber),

  };
  setFormData(formattedDisplayData);
  setEditOpen(true);
};


  const formatDateToMMDDYYYY = (date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    return `${month}-${day}-${year}`;
  };

const handleUpdate = async () => {
  const requiredFields = ['firstName','lastName','email','addressLine1','city','state','zipCode','dateOfBirth'];


  const newErrors = {};

  requiredFields.forEach((field) => {
    const err = validateField(field, formData[field]);
    if (err) newErrors[field] = err;
  });



  if (Object.keys(newErrors).length > 0) {
    setFormErrors(newErrors);
    return;
  }

  try {
    setIsUpdating(true);

    const customerId = formData?.id || displayData?.id;

    if (!customerId) {
      console.error("Customer ID is undefined. Cannot update details.");
      return;
    }

    const formattedDOB = formData.dateOfBirth
      ? formatDateToMMDDYYYY(formData.dateOfBirth)
      : null;


    const formattedFormData = {
      ...formData,
      dateOfBirth: formattedDOB,
      phoneNumber: toE164FromRaw10(formData.phoneNumber),
    };

    await dispatch(updateCustomerDetailsAction(formattedFormData, customerId));
      dispatch({
      type: 'CUSTOMER_SEARCH_LIST_SUCCESS',
      payload: {
        content: [formattedFormData],
        totalElements: 1,
        totalPages: 1,
        number: 0,
        size: 5,
      },
    });
    setEditOpen(false);
    dispatch(getCustomerDetailsByIdAction(customerId));
  } catch (error) {
    console.error("Error updating customer:", error);
  } finally {
    setIsUpdating(false);
  }
};

  const handleCreatePolicy = () => {
    navigate('/createpolicy', {
      state: {
        customerData: displayData
      }
    });
  }
  const [openZipCodeError, setOpenZipCodeError] = useState(false);

  const handleCloseZipCodeError = () => {
    setOpenZipCodeError(false);
  };

  const validateZipCode = (zipCode) => {
    return /^\d{5}$/.test(zipCode);
  };
  const handleCreateQuote = async() => {
    if (!validateZipCode(displayData.zipCode)) {
    setOpenZipCodeError(true);
    return;
  }
   try {
            // const updatedPhone = convertToE164(displayData.phoneNumber);
            const response = await dispatch(
              getQuoteInfoByFields(displayData.firstName, displayData.lastName, displayData.dateOfBirth, displayData.phoneNumber)
            );
            if (response && Array.isArray(response) && response.length > 0) {
              // setHasCheckedExisting(true);
              setExistingUsers(response);
              // setSelectedUser(response[0]);
              setDialogOpen(true);
                   dispatch({ type: 'RESET_GLOBAL_SEARCH_LOADING' });
            }
            else
            {
               dispatch({ type: "RESET_GENERALPARTYINFO" });
          dispatch({ type: "RESET_ALL_VEHICLE_INFO" });
          dispatch({ type: "RESET_ALL_DRIVER_INFO" });
          dispatch({ type: "RESET_ALL_RATES" });
              const customerData = {
              firstName: displayData.firstName,
              lastName: displayData.lastName,
              dateOfBirth: displayData.dateOfBirth,
              gender: displayData.gender,
              email: displayData.email,
              state: displayData.state,
              city: displayData.city,
              zipCode: displayData.zipCode,
              addressLine1: displayData.addressLine1,
              clientCustomerId:displayData.id,
              cellPhone:formatPhoneNumber(displayData.phoneNumber),
            };
              navigate('/', { state: { customerData } });
            }
              dispatch({ type: 'RESET_GLOBAL_SEARCH_LOADING' });
          } catch (error) {
            // setHasCheckedExisting(false);
            console.error("Error checking existing user:", error);

          }
  };
  return (
    <>
      {showCustomerData && (displayData || selectedCustomerDetails) && (
        <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              marginBottom: "20px",
            }}
          >
             <Tabs value={tabValue} 
             onChange={handleTabChange} aria-label="basic tabs example"
              sx={{
                fontFamily: `"Poppins", sans-serif`,
                '& .MuiTab-root': {
                  fontSize: '16px',
                  textTransform: 'none',
                  fontWeight: 500
                }
              }}
            >
                <Tab sx={{fontFamily: `"Poppins", sans-serif`,}} label="Customer Details" {...a11yProps(0)} />
                  {!accessDenied ? (
                    <Tab sx={{fontFamily: `"Poppins", sans-serif`,}}
                      label={`Quote (${
                      get_selected_quote_data_pagination?.totalElements || 0
                    })`}
                    {...a11yProps(1)}
                  />  ) : ''}
                  {!accessDenied ? ( <Tab sx={{fontFamily: `"Poppins", sans-serif`,}}
                    label={`Policies (${
                    customer_policy_pagination?.totalElements || 0
                  })`}
                {...a11yProps(2)}
              /> ) : ''}
              {!accessDenied ? ( <Tab sx={{fontFamily: `"Poppins", sans-serif`,}} label={`Notes (${notesTotalElement})`} {...a11yProps(3)} /> ) : ''}
              {!accessDenied ? ( <Tab sx={{fontFamily: `"Poppins", sans-serif`,}} label={`Tasks (${taskTotalElement})`} {...a11yProps(4)} /> ) : ''}
              {!accessDenied ? ( <Tab sx={{fontFamily: `"Poppins", sans-serif`,}} label="Communication" {...a11yProps(5)} />) : ''}
              {!accessDenied ? ( <Tab sx={{fontFamily: `"Poppins", sans-serif`,}} label="Attachment" {...a11yProps(6)} />) : ''}
              {!accessDenied ? ( <Tab sx={{fontFamily: `"Poppins", sans-serif`,}} label="Activity Log" {...a11yProps(7)} />) : ''}
            </Tabs>
          </Box>

          <CustomTabPanel value={tabValue} index={0}>
             {!accessDenied ? <><Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '10px', marginRight:'15px' }}>
              <IconButton onClick={handleEditClick} size="small">
                <EditIcon />
              </IconButton>
            </Box></> : ''}
           {isLoading && !isUpdating ? (
            <Backdrop
              sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
              open={true}
            >
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                <Loader />
              </Box>
            </Backdrop>
          ): (!accessDenied ?
              <Table sx={{ verticalAlign: "Top", padding: "0 10px", }}>
                
                <TableBody>
                  <TableRow sx={{ verticalAlign: "Top" }}>
                    <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>First Name:</strong>
                            </TableCell>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{displayData?.firstName}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>Middle Name:</strong>
                            </TableCell>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{displayData?.middleName}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>Last Name:</strong>
                            </TableCell>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{displayData?.lastName}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>ZipCode:</strong>
                            </TableCell>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{displayData?.zipCode}</TableCell>
                          </TableRow>
                           <TableRow>
                              <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>Updated By:</strong>
                              </TableCell>
                              <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              {displayData?.updatedBy?.name}
                              </TableCell>
                            </TableRow>
                             <TableRow>
                              <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>Location Agency Name:</strong>
                              </TableCell>
                              <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                                {displayData?.locationAgencyName}

                              </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableCell>

                    <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>Date of Birth:</strong>
                            </TableCell>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{displayData?.dateOfBirth}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>Email:</strong>
                            </TableCell>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{displayData?.email}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>Phone Number:</strong>
                            </TableCell>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              {toDisplayPhone(displayData?.phoneNumber)}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                              <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>Location Phone Number:</strong>
                              </TableCell>
                              <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              {formatPhoneNumberDisplay(displayData?.locationPhone)}
                              </TableCell>
                          </TableRow>
                           <TableRow>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                            <strong>Created By:</strong>
                            </TableCell>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                            {displayData?.createdBy?.name}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                          <strong>Updated Date:</strong>
                          </TableCell>
                          <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                          {displayData.updatedBy?.timestamp
                            ? formatDateToMMDDYYYY(displayData.updatedBy.timestamp)
                          : ''}
                              </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableCell>

                    <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>Address:</strong>
                            </TableCell>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{displayData?.addressLine1}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>City:</strong>
                            </TableCell>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{displayData?.city}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>State:</strong>
                            </TableCell>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{driverLicenseState.find((item) => item.value === displayData?.state)?.label || ""}</TableCell>
                          </TableRow>
                           <TableRow>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>Created Date:</strong>
                            </TableCell>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              {displayData.createdBy?.timestamp
                                ? formatDateToMMDDYYYY(displayData.createdBy.timestamp)
                                : ''}
                              </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            :
              <Table sx={{ verticalAlign: "Top", padding: "0 10px" }}>
                <TableBody>
                  <TableRow sx={{ verticalAlign: "Top" }}>

                    <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>First Name:</strong>
                            </TableCell>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{!accessDenied ? displayData?.firstName : customerSelecteCustomer.firstName}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>Middle Name:</strong>
                            </TableCell>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{!accessDenied ? displayData?.middleName : customerSelecteCustomer.middleName}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>Last Name:</strong>
                            </TableCell>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{!accessDenied ? displayData?.lastName : customerSelecteCustomer.lastName}</TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableCell>
                    <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>Date of Birth:</strong>
                            </TableCell>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{!accessDenied ? displayData?.dateOfBirth : customerSelecteCustomer.dateOfBirth}</TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>Phone Number:</strong>
                            </TableCell>
                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              {!accessDenied ? formatPhoneNumber(displayData?.phoneNumber) : customerSelecteCustomer.locationPhone}
                            </TableCell>
                          </TableRow>
                           <TableRow>
                              <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                              <strong>Location Agency Name:</strong>
                              </TableCell>
                              <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                                {!accessDenied ? displayData?.locationAgencyName : customerSelecteCustomer.locationAgencyName}

                              </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableCell>

                  </TableRow>
                </TableBody>
              </Table>
            )}
            <Box sx={{width:"100%", display:'flex', justifyContent: 'end', boxSizing: 'border-box',  mt:2,mb:2, px:2}}>
                <Button 
                  onClick={handleCreateQuote}
                  variant='outlined'
                  size='large'
                  sx={{margin: '0 15px'}}
                  >Create Quote
                </Button>
                <Button 
                  onClick={handleCreatePolicy}
                  variant='outlined'
                  size='large'
                  >
                    Create Policy
                </Button>
            </Box>
          </CustomTabPanel>
            <Dialog
              open={openZipCodeError}
              onClose={handleCloseZipCodeError}
              aria-labelledby="zipcode-error-dialog-title"
              aria-describedby="zipcode-error-dialog-description"
            >
              <DialogTitle id="zipcode-error-dialog-title">Invalid Zip Code</DialogTitle>
              <DialogContent>
                <DialogContentText id="zipcode-error-dialog-description">
                  Zip code must be exactly 5 digits.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseZipCodeError} color="primary" autoFocus>
                  OK
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={editOpen}
              onClose={(event, reason) => {
                if (reason === "backdropClick" || reason === "escapeKeyDown") {
                  return;
                }
                if (!isUpdating) {
                  setEditOpen(false);
                }
              }}
              maxWidth="md"
              fullWidth
              disableScrollLock={true}
              keepMounted={false}
              hideBackdrop={false}
              style={{ zIndex: 1300 }}
            >
              <Backdrop
                sx={{
                  color: '#fff',
                  zIndex: (theme) => theme.zIndex.modal + 1,
                  position: 'absolute'
                }}
                open={isUpdating}
              >
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Loader/>
                </Box>
              </Backdrop>

              <DialogTitle
              >
                Edit Customer Details
              </DialogTitle>

          <DialogContent>
            <Box sx={{ display: "flex", gap: 2, marginTop: 2, width: "100%" }}>
              <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "19.6px",
                    textAlign: "left",
                    marginBottom: "8px",
                  }}
                >
                  First Name <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  name="firstName"
                  fullWidth
                  value={formData.firstName || ""}
                  onChange={handleNameInput}
                  error={!!formErrors.firstName}
                  helperText={formErrors.firstName}
                  disabled={isUpdating}
                />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "19.6px",
                    textAlign: "left",
                    marginBottom: "8px",
                  }}
                >
                  Middle Name
                </Typography>
                <TextField
                  name="middleName"
                  fullWidth
                  value={formData.middleName || ""}
                  onChange={handleNameInput}
                  error={!!formErrors.middleName}
                  helperText={formErrors.middleName}
                  disabled={isUpdating}
                />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "19.6px",
                    textAlign: "left",
                    marginBottom: "8px",
                  }}
                >
                  Last Name <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  name="lastName"
                  fullWidth
                  value={formData.lastName || ""}
                  onChange={handleNameInput}
                  error={!!formErrors.lastName}
                  helperText={formErrors.lastName}
                  disabled={isUpdating}
                />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "19.6px",
                    textAlign: "left",
                    marginBottom: "8px",
                  }}
                >
                  Date of Birth <span style={{ color: "red" }}>*</span>
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePickerField
                    fieldName="dateOfBirth"
                    formData={formData}
                    handleDateChange={handleDateChange}
                    handleBlur={handleBlur}
                    touchedFields={touchedFields}
                    fieldErrors={fieldErrors}
                    disabled={isUpdating}
                  />
                </LocalizationProvider>

                {formErrors.dateOfBirth && (
                  <Typography
                    component="span"
                    sx={{
                      color: 'red',
                      fontSize: '0.875rem',
                      fontFamily: 'Poppins',
                      marginTop: '4px',
                    }}
                  >
                    {formErrors.dateOfBirth}
                  </Typography>
                )}
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: 2, marginTop: 2, width: "100%" }}>
              <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "19.6px",
                    textAlign: "left",
                    marginBottom: "8px",
                  }}
                >
                  Email <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  name="email"
                  fullWidth
                  value={formData.email || ""}
                  onChange={handleEmailInput}
                  error={!!formErrors.email}
                  helperText={formErrors.email}
                  disabled={isUpdating}
                />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
              <PhoneNumberField
                label="Phone"
                name="phoneNumber"
                value={formData.phoneNumber || ""}
                onChange={(e) => {

                  setFormData((prev) => ({ ...prev, phoneNumber: e.target.value }));
                  if (formErrors.phoneNumber) setFormErrors((p) => ({ ...p, phoneNumber: "" }));
                }}
                required
                disabled={isUpdating}
                labelStyle={{ fontSize: "14px", fontWeight: 500 ,mb:1 }}
              />
            </Box>


              <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "19.6px",
                    textAlign: "left",
                    marginBottom: "8px",
                  }}
                >
                  Address <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  name="addressLine1"
                  fullWidth
                  required
                  value={formData.addressLine1 || ""}
                  onChange={handleAddressInput}
                  error={!!formErrors.addressLine1}
                  helperText={formErrors.addressLine1}
                  disabled={isUpdating}
                />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "19.6px",
                    textAlign: "left",
                    marginBottom: "8px",
                  }}
                >
                  City <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  name="city"
                  fullWidth
                  required
                  value={formData.city || ""}
                  onChange={handleCityStateInput}
                  error={!!formErrors.city}
                  helperText={formErrors.city}
                  disabled={isUpdating}
                />
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: 2, marginTop: 2, width: "100%" }}>
              <Box sx={{ display: "flex", flexDirection: "column", width: "23.7%" }}>
                <Typography
                  variant="body1"
                  sx={{
                    color: "black",
                    fontWeight: "500",
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    lineHeight: "19.6px",
                    textAlign: "left",
                    marginBottom: "8px",
                  }}
                >
                  State <span style={{ color: "red" }}>*</span>
                </Typography>

                <FormControl fullWidth>
                  <Select
                    name="state"
                    value={formData.state || ""}
                    onChange={(e) => {
                      handleCityStateInput(e);
                      if (formErrors.state) {
                        setFormErrors({ ...formErrors, state: '' });
                      }
                    }}
                    displayEmpty
                    error={!!formErrors.state}
                    disabled={isUpdating}
                    sx={{
                      fontFamily: 'Poppins',
                      height: '56px',
                      textAlign: 'left',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          textAlign: 'center',
                        },
                      },
                    }}
                  >
                    <MenuItem value="" disabled>Select State</MenuItem>
                    {driverLicenseState.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {formErrors.state && (
                  <Typography
                    component="span"
                    sx={{
                      color: 'red',
                      fontSize: '0.875rem',
                      fontFamily: 'Poppins',
                      marginTop: '4px',
                    }}
                  >
                    {formErrors.state}
                  </Typography>
                )}
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", width: "23.7%" }}>
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "19.6px",
                    textAlign: "left",
                    marginBottom: "8px",
                  }}
                >
                  Zip Code <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  name="zipCode"
                  fullWidth
                  required
                  value={formData.zipCode || ""}
                  onChange={handleZipCodeInput}
                  error={!!formErrors.zipCode}
                  helperText={formErrors.zipCode}
                  disabled={isUpdating}
                />
              </Box>
            </Box>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={() => setEditOpen(false)}             
              disabled={isUpdating}
              variant='outlined'
              size='large'
            >
              Cancel
            </Button>
            <Button
              onClick={handleUpdate}
              disabled={isUpdating}              
              variant='outlined'
              size='large'
            >
              {isUpdating ? 'Updating...' : 'Update'}
            </Button>
          </DialogActions>
        </Dialog>
        {!accessDenied ? (
          <>
          <CustomTabPanel value={tabValue} index={1}>
            <TableContainer
              component={Paper}
              sx={{
                maxWidth: "95%",
                marginLeft: 4,
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="styled-table-heading">
                      Quote Number
                    </TableCell>
                    <TableCell className="styled-table-heading">Name</TableCell>
                    <TableCell className="styled-table-heading">DOB</TableCell>
                    <TableCell className="styled-table-heading">
                      Phone Number
                    </TableCell>
                    <TableCell className="styled-table-heading">
                      Email
                    </TableCell>
                    <TableCell className="styled-table-heading">
                      Source
                    </TableCell>
                    <TableCell className="styled-table-heading">
                      License Number
                    </TableCell>
                    <TableCell className="styled-table-heading">
                      Effective Date
                    </TableCell>
                    <TableCell className="styled-table-heading">
                      Expiry Date
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {get_selected_quote_data.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan="9" align="center">
                        <NoDataFound/>
                      </TableCell>
                    </TableRow>
                  ) : (
                    get_selected_quote_data.map((row) => (
                      <TableRow
                        key={row.quoteNumber}
                        onClick={() => handleRowClickQuotesWithDialog(row.quoteNumber)}
                        sx={{ cursor: 'pointer' }}
                      >
                        <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{row.quoteNumber}</TableCell>
                        <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{row.name}</TableCell>
                        <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{row.dateOfBirth}</TableCell>
                       <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{formatPhoneNumberDisplay(row.phoneNumber)}</TableCell>
                        <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{row.email}</TableCell>
                        <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{row.source}</TableCell>
                        <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{row.licenseNumber}</TableCell>
                        <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{row.effDate}</TableCell>
                        <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{row.expDate}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {get_selected_quote_data_pagination.totalElements > 0 && (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    padding: '16px 0',
                    gap: 2,
                  }}
                >
                  <Box display="flex" alignItems="center">
                    <Typography variant="body2" sx={{ fontSize: '13px', marginRight: '8px' }}>
                      Rows per page:
                    </Typography>
                    <FormControl size="small" sx={{ minWidth: 80 }}>
                      <Select
                        value={customerRowsPerPage}
                        onChange={handleQuoteChangeRowsPerPage}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Rows per page' }}
                        sx={{ fontSize: '13px' }}
                      >
                        {[5, 10, 15, 25, 50, 100].map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  <Pagination
                    count={Math.ceil(get_selected_quote_data_pagination.totalElements / customerRowsPerPage)}
                    page={customerPage + 1}
                    onChange={(e, value) => handleQuotePolicyChangePage(e, value - 1)}
                    showFirstButton
                    showLastButton
                    siblingCount={1}
                    boundaryCount={1}
                    size="small"
                  />
                </Box>
              )}

          </CustomTabPanel>

          <CustomTabPanel value={tabValue} index={2}>
            <CustomerPolicyListing
              id={id}
              client_Customer_Id={clientCustomerId}
              selected_customer_list={selected_customer_list}
              handlePolicyRowClick={handlePolicyRowClick}
              policyPage={policyPage}
              handlePolicyChangeRowsPerPage={handlePolicyChangeRowsPerPage}
              handlePolicyChangePage={handlePolicyChangePage}
              policyRowsPerPage={policyRowsPerPage}
              customer_policy_pagination={customer_policy_pagination}
            />
          </CustomTabPanel>
          <CustomTabPanel value={tabValue} index={3}>
            <GlobalNotes
              setSearchPerformed={setSearchPerformed}
              selected_customer_list={selected_customer_list}
              handlePolicyRowClick={handlePolicyRowClick}
              policyPage={policyPage}
              handlePolicyChangeRowsPerPage={handlePolicyChangeRowsPerPage}
              handlePolicyChangePage={handlePolicyChangePage}
              policyRowsPerPage={policyRowsPerPage}
              customer_policy_pagination={customer_policy_pagination}

              customerId={clientCustomerId || selectedCustomerDetails?.id}
            />

          </CustomTabPanel>
          <CustomTabPanel value={tabValue} index={4}>

            <GlobalTask
              customerId={clientCustomerId || selectedCustomerDetails?.id}
              selected_customer_list={selected_customer_list}
            />
          </CustomTabPanel>
          <CustomTabPanel value={tabValue} index={5}>
            <CommunicationTable
              selected_customer_list={selected_customer_list}
              customerId={selectedCustomerDetails?.id}
            />
          </CustomTabPanel>
          <CustomTabPanel value={tabValue} index={6}>
            <Attachments

              customerId={clientCustomerId || selectedCustomerDetails?.id}
            />
          </CustomTabPanel>
          <CustomTabPanel value={tabValue} index={7}>
            <GlobalActivityLog
              customerId={selectedCustomerDetails?.id}
              selected_customer_list={selected_customer_list}
            />
          </CustomTabPanel>
          </>
          ) : ""}

          {/* Effective Date Dialog */}
          <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            disableScrollLock={true}
            keepMounted={false}
            hideBackdrop={false}
            style={{ zIndex: 1300 }}
            sx={{
              '& .MuiDialog-paper': {
                borderRadius: '16px',
                padding: '24px',
                maxWidth: '500px',
                width: '90%',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                background: 'linear-gradient(145deg, #ffffff, #f9fafb)',
              },
            }}
          >
            <DialogTitle
              sx={{
                fontSize: '1.5rem',
                fontWeight: 600,
                color: '#FFAE00',
                textAlign: 'center',
                paddingBottom: '8px',
                position: 'relative',
              }}
            >
              Confirm Policy Effective Date
              <IconButton
                onClick={handleCloseDialog}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: '#9ca3af',
                  '&:hover': {
                    color: '#000',
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>

            <DialogContent
              sx={{
                padding: '16px 24px',
              }}
            >
              <Typography variant="body1" sx={{ mb: 3, textAlign: 'center' }}>
                The Effective Date of this quote is in the past. Some carriers may not rate.
              </Typography>
              <FormControl component="fieldset" fullWidth>
                <RadioGroup
                  value={selectedOption}
                  onChange={handleOptionChange}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                  }}
                >
                  <FormControlLabel
                    value="today"
                    control={
                      <Radio
                        sx={{
                          color: '#4b5e6d',
                          '&.Mui-checked': {
                            color: '#1976d2',
                          },
                        }}
                      />
                    }
                    label="Set to Today"
                    sx={{
                      backgroundColor: '#f1f5f9',
                      borderRadius: '8px',
                      padding: '8px 12px',
                      margin: 0,
                      '& .MuiFormControlLabel-label': {
                        fontSize: '1rem',
                        fontWeight: 500,
                        color: '#1a1a1a',
                      },
                      transition: 'background-color 0.2s ease',
                      '&:hover': {
                        backgroundColor: '#e2e8f0',
                      },
                    }}
                  />

                  <FormControlLabel
                    value="setTo"
                    control={
                      <Radio
                        sx={{
                          color: '#4b5e6d',
                          '&.Mui-checked': {
                            color: '#1976d2',
                          },
                        }}
                      />
                    }
                    label={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                        <span>Set to</span>
                        <Box sx={{ flex: 1, minWidth: '150px' }}>
                          <DatePickerBot
                            entry={{
                              id: 'dialogDate',
                              startDate: customDate,
                              isPrefilled: false,
                              isEditing: true,
                            }}
                            handleInputChange={(id, field, value) => {
                              if (id === 'dialogDate' && field === 'startDate') {
                                setCustomDate(value);
                              }
                            }}
                          />
                        </Box>
                      </Box>
                    }
                    sx={{
                      backgroundColor: '#f1f5f9',
                      borderRadius: '8px',
                      padding: '8px 12px',
                      margin: 0,
                      '& .MuiFormControlLabel-label': {
                        fontSize: '1rem',
                        fontWeight: 500,
                        color: '#1a1a1a',
                        width: '100%'
                      },
                      transition: 'background-color 0.2s ease',
                      '&:hover': {
                        backgroundColor: '#e2e8f0',
                      },
                    }}
                  />
                </RadioGroup>
              </FormControl>
            </DialogContent>
            <DialogActions
              sx={{
                padding: '16px 24px',
                display: 'flex',
                gap: '12px',
                justifyContent: 'center',
                flexWrap: 'wrap'
              }}
            >
              <Button
                variant="contained"
                onClick={handleSetEffectiveDate}
                className="btn-primary"
                sx={{
                  backgroundColor: '#22c55e',
                  color: '#ffffff',
                  fontWeight: 600,
                  textTransform: 'none',
                  padding: '8px 24px',
                  borderRadius: '8px',
                  '&:hover': {
                    backgroundColor: '#16a34a',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                  },
                  transition: 'all 0.2s ease',
                  flex: isMobile ? '1 1 100%' : 'none',
                }}
              >
                Set Effective Date
              </Button>
              <Button
                variant="outlined"
                onClick={handleProceedWithExistingDate}
                sx={{
                  borderColor: '#d1d5db',
                  color: '#4b5e6d',
                  fontWeight: 600,
                  textTransform: 'none',
                  padding: '8px 24px',
                  borderRadius: '8px',
                  '&:hover': {
                    backgroundColor: '#f1f5f9',
                    borderColor: '#9ca3af',
                  },
                  transition: 'all 0.2s ease',
                  flex: isMobile ? '1 1 100%' : 'none',
                }}
              >
                Keep Existing Date
              </Button>
            </DialogActions>
          </Dialog>
           {/* quote dialog */}
      <Dialog
  open={dialogOpen}
  onClose={handleCancelDialog}
  aria-labelledby="alert-dialog-title"
  maxWidth="sm"
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: 3,
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
      maxWidth: isMobile ? "95%" : "500px",
      width: "100%",
      overflow: 'hidden',
    }
  }}
>
  {/* Modern Header */}
  <DialogTitle
    sx={{
      fontFamily: '"Poppins", sans-serif',
      fontSize: { xs: '1.25rem', sm: '1.5rem' },
      fontWeight: 600,
      background: 'linear-gradient(135deg, #E69C00 0%, rgba(230, 156, 0, 0.8) 100%)',
      color: '#ffffff',
      padding: { xs: '20px 16px', sm: '24px 24px' },
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'radial-gradient(circle at top right, rgba(255,255,255,0.1) 0%, transparent 60%)',
      }
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, position: 'relative' }}>
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(10px)',
        }}
      >
        📋
      </Box>
      <Box>
        <Typography sx={{ fontSize: { xs: '1.1rem', sm: '1.3rem' }, fontWeight: 600, lineHeight: 1.2 }}>
          Previous Quote Found
        </Typography>
        <Typography sx={{ fontSize: '0.875rem', opacity: 0.9, fontWeight: 400, mt: 0.5 }}>
          {existingUsers.length} {existingUsers.length === 1 ? 'quote' : 'quotes'} available
        </Typography>
      </Box>
    </Box>
  </DialogTitle>

  <DialogContent sx={{ padding: { xs: '24px 16px', sm: '32px 24px' }, backgroundColor: '#f8f9fa',marginTop:"5" }}>
    {/* Compact Dropdown Selector */}
    <FormControl fullWidth sx={{ mb: 3 }}>
      <InputLabel
        sx={{
          fontFamily: '"Poppins", sans-serif',
          color: '#495057',
          fontWeight: 500,
          marginTop:3,
          '&.Mui-focused': { color: '#E69C00' }
        }}
      >
        Select Quote
      </InputLabel>
      <Select
        value={selectedUser?.gpId || ''}
        onChange={(e) => {
          const user = existingUsers.find(u => u.gpId === e.target.value);
          handleUserSelection(user);
        }}
        label="Select Quote"
        size="small"
        sx={{
          fontFamily: '"Poppins", sans-serif',
          backgroundColor: '#ffffff',
          borderRadius: 2,
          marginTop:3,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.12)',
            borderWidth: '2px',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(230, 156, 0, 0.4)',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E69C00',
          },
        }}
      >
        {existingUsers.map((user) => (
          <MenuItem
            key={user.gpId}
            value={user.gpId}
            sx={{
              fontFamily: '"Poppins", sans-serif',
               py: 0.5,
        px: 1.5,
              // padding: '12px 16px',
              '&:hover': { backgroundColor: 'rgba(230, 156, 0, 0.08)' },
              '&.Mui-selected': {
                backgroundColor: 'rgba(230, 156, 0, 0.12)',
                '&:hover': { backgroundColor: 'rgba(230, 156, 0, 0.18)' },
              }
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, width: '100%' }}>
              <Typography sx={{ fontWeight: 600, fontSize: '0.8rem', color: '#212529' }}>
                🔖 Quote ID: {user.quoteId}
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Typography sx={{ fontSize: '0.85rem', color: '#495057' }}>
                  👤 {user.firstName} {user.lastName}
                </Typography>
                <Typography sx={{ fontSize: '0.85rem', color: '#6c757d' }}>
                  📅 DOB: {user.dob}
                </Typography>
              </Box>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>

    {/* Selected Quote Details Card */}
    {selectedUser && (
      <Box
        sx={{
          padding: '16px',
          borderRadius: 2,
          background: 'linear-gradient(135deg, rgba(230, 156, 0, 0.08) 0%, rgba(230, 156, 0, 0.04) 100%)',
          border: '2px solid #E69C00',
          mb: 3,
        }}
      >
        <Typography sx={{ fontFamily: '"Poppins", sans-serif', fontSize: '0.85rem', fontWeight: 600, color: '#E69C00', mb: 1 }}>
          Selected Quote Details:
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
          <Typography sx={{ fontFamily: '"Poppins", sans-serif', fontSize: '0.9rem', color: '#212529' }}>
            <strong>Quote ID:</strong> {selectedUser.quoteId}
          </Typography>
          <Typography sx={{ fontFamily: '"Poppins", sans-serif', fontSize: '0.9rem', color: '#212529' }}>
            <strong>Name:</strong> {selectedUser.firstName} {selectedUser.lastName}
          </Typography>
          <Typography sx={{ fontFamily: '"Poppins", sans-serif', fontSize: '0.9rem', color: '#212529' }}>
            <strong>DOB:</strong> {selectedUser.dob}
          </Typography>
        </Box>
      </Box>
    )}

    {/* Radio Group */}
    <Box
      sx={{
        padding: { xs: '16px', sm: '20px' },
        borderRadius: 2,
        background: '#ffffff',
        border: '2px solid rgba(230, 156, 0, 0.1)',
      }}
    >
      <FormControl component="fieldset" fullWidth>
        <FormLabel
          component="legend"
          sx={{
            fontFamily: '"Poppins", sans-serif',
            color: '#212529',
            fontWeight: 600,
            fontSize: '0.95rem',
            marginBottom: 2,
          }}
        >
          Use this quote for new application?
        </FormLabel>
        <RadioGroup
          row
          name="use-gpid"
          value={useGpId ? "yes" : "no"}
          onChange={handleGpIdChange}
          sx={{ gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}
        >
          <FormControlLabel
            value="yes"
            control={<Radio sx={{ color: 'rgba(230, 156, 0, 0.6)', '&.Mui-checked': { color: '#E69C00' } }} />}
            label={<Typography sx={{ fontFamily: '"Poppins", sans-serif', fontSize: '0.9rem' }}>Yes, use existing quote</Typography>}
          />
          <FormControlLabel
            value="no"
            control={<Radio sx={{ color: 'rgba(230, 156, 0, 0.6)', '&.Mui-checked': { color: '#E69C00' } }} />}
            label={<Typography sx={{ fontFamily: '"Poppins", sans-serif', fontSize: '0.9rem' }}>No, create new quote</Typography>}
          />
        </RadioGroup>
      </FormControl>
    </Box>
  </DialogContent>

  {/* Action Buttons */}
  <DialogActions sx={{ padding: { xs: '16px', sm: '20px 24px' }, backgroundColor: '#ffffff', borderTop: '1px solid rgba(0, 0, 0, 0.08)', gap: 1.5 }}>
    <Button
      onClick={handleCancelDialog}
      sx={{
        fontFamily: '"Poppins", sans-serif',
        color: '#6c757d',
        fontSize: '0.95rem',
        fontWeight: 500,
        padding: { xs: '8px 20px', sm: '10px 24px' },
        borderRadius: 2,
        textTransform: 'none',
        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
      }}
    >
      Cancel
    </Button>
    <Button
      onClick={handleConfirmDialog}
      variant="contained"
      autoFocus
      disabled={!selectedUser}
      sx={{
        fontFamily: '"Poppins", sans-serif',
        fontSize: '0.95rem',
        fontWeight: 600,
        padding: { xs: '8px 24px', sm: '10px 32px' },
        borderRadius: 2,
        textTransform: 'none',
        background: 'linear-gradient(135deg, #E69C00 0%, rgba(230, 156, 0, 0.9) 100%)',
        boxShadow: '0 4px 12px rgba(230, 156, 0, 0.3)',
        transition: 'all 0.3s ease',
        '&:hover': {
          background: '#E69C00',
          boxShadow: '0 6px 20px rgba(230, 156, 0, 0.4)',
          transform: 'translateY(-2px)',
        },
      }}
    >
      Confirm Selection
    </Button>
  </DialogActions>
</Dialog>
        </Box>
      )}
    </>
  );
};

export default CustomerData;